import script from "./icon-minus.vue?vue&type=script&lang=ts&setup=true"
export * from "./icon-minus.vue?vue&type=script&lang=ts&setup=true"

import "./icon-minus.vue?vue&type=style&index=0&id=46c1d602&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-46c1d602"]])

export default __exports__